import { useState } from 'react';

const NearbyMerchantsSkeleton = ({ count = 24 }) => {
  const [dummyArray] = useState(Array.from({ length: count }));

  return (
    <section className="pt-6 pb-20 lg:pb-40 px-2 md:px-4 lg:px-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
        {dummyArray.map((_, idx) => (
          <div key={idx} className="rounded-lg border border-[#e9e9e9] overflow-hidden cursor-default">
            
            {/* Banner skeleton */}
            <div className="h-[150px] sm:h-[180px] md:h-[200px] w-full bg-gray-300 relative overflow-hidden animate-shimmer">
              <div className="absolute top-0 left-0 h-full w-1/2 bg-white opacity-30 transform -translate-x-full animate-shimmer"></div>
            </div>

            {/* Details skeleton */}
            <div className="bg-white py-[14px] px-3 md:px-4 flex items-center gap-3">
              
              {/* Logo skeleton */}
              <div className="w-[62px] h-[62px] bg-gray-300 rounded-lg relative overflow-hidden">
                <div className="absolute top-0 left-0 h-full w-1/2 bg-white opacity-30 transform -translate-x-full animate-shimmer"></div>
              </div>

              {/* Single text bar */}
              <div className="flex-1 h-4 bg-gray-300 rounded relative overflow-hidden">
                <div className="absolute top-0 left-0 h-full w-1/2 bg-white opacity-30 transform -translate-x-full animate-shimmer"></div>
              </div>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NearbyMerchantsSkeleton;